import React, { Component } from 'react';
import QRReader from '@components/QR/read';
import { NotificationManager } from 'react-notifications';

class QRReaderModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      qrData: '',
      scanCount: 0
    };
  }
  

  handleScan = (data) => {
    if (data) {
      this.setState({ 
        qrData: data,
        scanCount: this.state.scanCount + 1
      });
      
      // Verificar se é um QR Code válido (começa por "A:")
      if (data.startsWith('A:')) {
        // Notificar que QR foi lido
        NotificationManager.success('QR Code lido com sucesso!', 'Sucesso', 2000);
        
        // Passar dados para o componente pai
        if (this.props.onQRScanned) {
          this.props.onQRScanned(data, 'camera');
        }
      } else if (data.startsWith('AÇ')) {
        // Notificar que QR foi lido
        NotificationManager.success('QR Code lido com sucesso!', 'Sucesso', 2000);
        
        // Passar dados para o componente pai
        if (this.props.onQRScanned) {
          this.props.onQRScanned(data.replace(/\(/g, "*").replace(/Ç/g, ":"), 'camera');
        }
      } else {
        // Notificar que não é um QR Code válido
        NotificationManager.warning('QR Code não reconhecido. Deve começar por "A:"', 'Aviso', 3000);
      }
    }
  }

  handleError = (err) => {
    console.error('QR Scanner Error:', err);
    NotificationManager.error('Erro ao ler QR Code', 'Erro', 3000);
  }

  handleClose = () => {
    this.setState({ qrData: '', scanCount: 0 });
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  render() {
    const { isOpen } = this.props;
    const { qrData, scanCount } = this.state;

    // Se não estiver aberto, não renderizar nada
    if (!isOpen) {
      return null;
    }

    // Modal simples para teste
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div style={{
          backgroundColor: 'white',
          padding: '30px',
          borderRadius: '10px',
          maxWidth: '500px',
          width: '90%',
          textAlign: 'center'
        }}>
          <h2><span role="img" aria-label="Scanner">🔍</span> Leitor de QR Code</h2>
          
          {qrData && (
            <div style={{ 
              marginBottom: '20px', 
              padding: '15px', 
              backgroundColor: '#f0f8ff', 
              borderRadius: '5px',
              border: '1px solid #007bff'
            }}>
              <h4>QR Code Lido:</h4>
              <p style={{ 
                wordBreak: 'break-all', 
                fontSize: '14px',
                fontFamily: 'monospace',
                backgroundColor: '#fff',
                padding: '10px',
                borderRadius: '3px',
                border: '1px solid #ddd'
              }}>
                {qrData}
              </p>
              <p style={{ fontSize: '12px', color: '#666' }}>
                Leituras: {scanCount}
              </p>
            </div>
          )}
          
          <div style={{ 
            border: '2px dashed #ccc', 
            borderRadius: '10px', 
            padding: '20px',
            marginBottom: '20px'
          }}>
            <p style={{ marginBottom: '20px' }}>Câmera QR Reader:</p>
            <QRReader
              onScan={this.handleScan}
              onError={this.handleError}
              delay={300}
              style={{ width: '100%', maxWidth: '400px' }}
            />
          </div>
          
          <div style={{ marginTop: '20px' }}>
            <button
              onClick={this.handleClose}
              style={{
                padding: '10px 20px',
                backgroundColor: '#6c757d',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                marginRight: '10px'
              }}
            >
              Fechar
            </button>
            <button
              onClick={() => this.setState({ qrData: '', scanCount: 0 })}
              style={{
                padding: '10px 20px',
                backgroundColor: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer'
              }}
            >
              Limpar
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default QRReaderModal;
